import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Clearfix,
  Modal,
} from 'react-bootstrap';

import { tryHandleGraphQLError } from '../../utils/graphQLErrorHandlers';

export const confirmModalPropTypes = {
  showModal: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export const withConfirmModalState = withStateHandlers(
  (props) => { return { showModal: false }; },
  {
    openModal: (state, props) => {
      return () => { return { showModal: true }; };
    },
    closeModal: (state, props) => {
      return () => { return { showModal: false }; };
    },
  },
);

const propTypes = exact({
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string,
  dismissButtonText: PropTypes.string,
  confirmAction: PropTypes.func.isRequired,
  showDismissButton: PropTypes.bool,

  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
});

export class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.resetAndClose = this.resetAndClose.bind(this);
  }

  async handleConfirm() {
    const { confirmAction, onHide } = this.props;
    try {
      await confirmAction();
      onHide();
    } catch (e) {
      const message = tryHandleGraphQLError(e);
      this.setState({ errorMessage: message });
    }
  }

  resetAndClose() {
    const { onHide } = this.props;
    this.setState({ errorMessage: '' });
    onHide();
  }

  render() {
    const {
      show,
      onHide,
      title,
      message,
      confirmButtonText,
      dismissButtonText,
      showDismissButton,
    } = this.props;

    const { errorMessage } = this.state;

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Clearfix>
            <div>{message}</div>
            <ButtonToolbar className="pull-right">
              { showDismissButton && (
                <Button
                  bsStyle="warning"
                  onClick={this.resetAndClose}
                >
                  {dismissButtonText}
                </Button>
              )}
              <Button
                bsStyle="primary"
                type="submit"
                onClick={this.handleConfirm}
              >
                {confirmButtonText}
              </Button>
            </ButtonToolbar>
          </Clearfix>
          {errorMessage && <strong> {errorMessage}</strong>}
        </Modal.Body>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = propTypes;

ConfirmModal.defaultProps = {
  confirmButtonText: 'Submit',
  dismissButtonText: 'Cancel',
  showDismissButton: true,
};

export default ConfirmModal;
